import { object, string, z } from "zod";
import { TreatmentSchema } from "./concierge";

export const ValidTreatmentSettingsSchema = TreatmentSchema;
export type ValidTreatmentSettings = z.infer<
  typeof ValidTreatmentSettingsSchema
>;

export const ValidatedTreatmentSchema = object({
  id: string(),
  settings: ValidTreatmentSettingsSchema,
  weight: z.number(),
});

export type ValidatedTreatment = z.infer<typeof ValidatedTreatmentSchema>;
